import React from 'react';
import {NextPage} from 'next';
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import WaveLayout from "../src/layouts/WaweLayout";
import * as styled from "../src/components/subpageHeroArea/ApplicationSubpageStyled";
import CareerApplication from "../src/components/careerApplication/CareerApplication";
import BreadcrumbComp from "../src/components/breadcrumb/BreadcrumbComp";
import GeneralFormCareerComp from "../src/components/generalForm/GeneralFormCareerComp";
import TextArea from "../src/components/textArea/TextArea";
import ButtonComp from "../src/components/buttons/buttonComp/buttonComp";
import SubpageHeroArea from "../src/components/subpageHeroArea/SubpageHeroArea";
import {NavigationURLs} from "../src/functions/NavigationFunctions";

const DijitalSatisData = {
    title: 'Genel Başvuru',
    text: '<p> Başvurduğunuz bu ilan "Genel Başvuru" niteliğindedir. Belirli bir pozisyona bağlı olarak yayınlanmamaktadır. Bu ilana yapılan başvurular, farklı departmanlarda değerlendirilmek, iş tecrübesine sahip olmak, deneyim kazanmak ve potansiyellerini gerçekleştirmek isteyen; kendine güvenen, öğrenmeye istekli ve bilişim sektörüne ilgi duyan, oluşabilecek tüm pozisyonlar için ihtiyaçlar doğrultusunda değerlendirme alınacaktır. </p> <p> Panjur Bilişim\'e göstermiş olduğunuz ilgiden dolayı teşekkür eder, çalışma yaşamınızda başarılar dileriz. </p>'
}

const KariyerBasvuru: NextPage = () => {
    const breadcrumbGenelBasvuru = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Kariyer', link: NavigationURLs.career},
        { label: 'Genel Başvuru'}
    ];

    return (
        <React.Fragment>
            <HtmlHead pageTitle="Kariyer Başvuru | Pembe Panjur"
                        description="Pembe Panjur kariyer başvuru sayfası ile ilgili detaylara sayfamızdan ulaşabilirsiniz."
            />
            <WaveLayout
                backgroundColor={'#D2147D'}
                loginButtonText={false}
                sloganOne={''}
                sloganTwo={''}
                homeButton={true}
                className={'career_page'}
                extraChildren={
                    <React.Fragment>
                        <styled.ApplicationSubpage className={'mobile-bgc-white'}>
                            <styled.ApplicationSubpageContainer className={'mb-0'}>
                                <styled.ApplicationSubpageWrapper>
                                    <BreadcrumbComp/>
                                    <CareerApplication title={DijitalSatisData.title} text={DijitalSatisData.text} breadcrumb={breadcrumbGenelBasvuru}/>
                                </styled.ApplicationSubpageWrapper>
                                <styled.ApplicationSubpageWrapper>
                                    <GeneralFormCareerComp
                                        title={'Başvuruyu gönder'} textareaTitle={'Hakkında'}
                                                     textareaPlaceholder={'Lütfen kısaca hakkınızda bilgilendirme yapın.'}
                                                     careerUpload={true} pageTitle={'genel_basvuru'}
                                    />
                                </styled.ApplicationSubpageWrapper>
                            </styled.ApplicationSubpageContainer>
                        </styled.ApplicationSubpage>
                    </React.Fragment>
                }
            >
                <SubpageHeroArea desktopHidden={true}>
                    <styled.CareerApplicationHeroAreaContent>
                        <TextArea>
                            <h2>
                                Pembe Panjur KARİYER
                            </h2>
                        </TextArea>
                        <ButtonComp fullWidth={true} backgroundColor={'#FFFFFF'} visible={false} uppercase={true} textColor={false} url={'#'}>
                            <React.Fragment>
                                Genel Başvuru
                            </React.Fragment>
                        </ButtonComp>
                    </styled.CareerApplicationHeroAreaContent>
                </SubpageHeroArea>
            </WaveLayout>
        </React.Fragment>
    );
}

import { checkAuthAndRedirect } from '../src/utils/authHelper';
export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};

export default KariyerBasvuru;
